/**
 * @file loader.tsx
 * @module Global/loader
 * @description Renders the reusable loading indicator used while asynchronous pages and data tables are fetching data.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

import BeatLoader from "react-spinners/BeatLoader";

const Loader = (props: any) => {
  return (
    <BeatLoader
      color={"#1b74e4"}
      loading={props.loading}
      size={20}
      aria-label="Loading Spinner"
      data-testid="loader"
    />
  );
};
export default Loader;
